import axios from '../utils/index';
import { Pat } from '@/typings/request';
const b2bCategoriesApi = {
    async getCategoryList(params: Pat) {
        return axios.get(`/b2b-category/list`, { params });
    },
    async addCategory(data: Pat) {
        return axios.post(`/b2b-category`, data);
    },
    async updateCategory(categoryId: string, data: Pat) {
        return axios.put(`/b2b-category/${categoryId}`, data);
    },
    async maxPosition() {
        return axios.get(`/b2b-category/max-position`);
    },
    async deleteCategory(categoryId: string) {
        return axios.delete(`/b2b-category/${categoryId}`);
    },
};

export default b2bCategoriesApi;
